<template>
    <table class="historial-table custom-table">
        <thead>
            <tr>
                <th>Fecha</th>
                <th>Infracción</th>
                <th>Estado</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in props.data" :key="index">
                <td>{{ formatDate(item.act.createdAt) }}</td>
                <td>{{ item.infraType.type + item.act.act_number.toString().padStart(6, '0') }}</td>
                <td>{{ item.currentState.state.state_name }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
const props = defineProps({
    data: Array
});
const formatDate = (dateString) => {
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  return new Date(dateString).toLocaleDateString("es-ES", options);
}
</script>

<style>
.historial-table {
  height: 100%;
  overflow-y: auto;
}

/*estilos para tabla */
.custom-table {
  width: 100%;
  border-collapse: separate;
  /* Cambia a 'separate' para permitir el espaciado entre celdas */
  border-spacing: 5 10px;
  /* Agrega espaciado vertical entre las filas */
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: center;
}

.custom-table th {
  background-color: rgba(0, 195, 168, 0.2);
  border-radius: 5px;
  /*text-align: left; habilitar si se quieren titulos a la izq*/
}

.custom-table td {
  background-color: transparent;
  /* Elimina el fondo de las celdas del cuerpo */
}
</style>